/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
import { useState, useMemo, useEffect } from 'react'
import '../../../scss/common/form/createEditFrom/CreateEditForm.scss'
import {
  Panel,
  ButtonToolbar,
  Col,
  SelectPicker,
  DatePicker,
  RadioGroup,
  Radio
} from 'rsuite'
import CreateTemplate from 'pages/template/createEditTemplate/CreateEditTemplate'
import {
  Button,
  Modal,
  Row,
  Section,
  TextInput,
  FormikErrorMessage,
  WhatsAppPreview,
  SMSTemplatePreview,
  AdvertisementTemplateView
} from 'shared'
import { Formik, Form, FormikProps, FormikHelpers } from 'formik'
import { notifyError, notifySuccess } from 'utils'
import Plus from '@rsuite/icons/Plus'
import CreateEditAudiences from 'pages/audience/createEditAudience/CreateEditAudiences'
import { useGetChannelOnboardingsQuery } from 'pages/channelOnBoarding/channelOnboardingApiSlice'
import {
  useFetchAudienceListQuery,
  useFetchAudienceCountQuery,
  useCreateCampaignMutation,
  useUpdateCampaignMutation,
  useCreateAppCampaignMutation,
  useUpdateWhatsappCampaignMutation
} from '../campaignApiSlice'
import {
  useGetTemplatesQuery,
  useFetchAdvertisementListQuery
} from '../../template/templateApiSlice'
import {
  compaignValidationSchema,
  defaultCompaignFormValues,
  CompaignForm,
  getInitialFormValuesResponse,
  COMPAIGN_FORM_FIELDS
} from '../utils'
import { AppCampaign, Campaign, CAMPAIGNSTATUS, CHANNEL } from '../types'
import { Advertisement, WhatsAppTemplate } from '../../template/types'

interface CreateEditCampaignProps {
  open: boolean;
  onClose: () => void;
  campaign: Campaign | null;
  isCopyMode: boolean;
  isEditMode: boolean;
  defaultType?: any;
}

const CreateEditCampaign: React.FC<CreateEditCampaignProps> = ({
  campaign,
  open,
  isEditMode,
  onClose,
  isCopyMode,
  defaultType = CHANNEL.WHATSAPP
}) => {
  const {
    NAME,
    DESCRIPTION,
    SCHEDULE_DATE_TIME,
    SCHEDULE_END_DATE,
    CHANNEL_TYPE
  } = COMPAIGN_FORM_FIELDS

  const campaignId = campaign?.id ?? undefined

  const {
    data: audienceData,
    isLoading: isAudienceLoading,
    refetch: refetchAudienceList
  } = useFetchAudienceListQuery()
  const [audienceId, setAudienceId] = useState<number | null>(null)
  const [selectedTemplate, setSelectedTemplate] =
    useState<WhatsAppTemplate | null>(null)

  const [selectedAdvertisementTemplate, setSelectedAdvertisementTemplate] =
    useState<Advertisement | null>(null)
  const [whatsAppPreview, setWhatsAppPreview] = useState<boolean>(false)
  const [isCompaignAdvertisement] = useState<boolean>(true)
  const [SMSPreview, setSMSPreview] = useState<boolean>(false)
  const [AdvertisementPreview, setAdvertisementPreview] =
    useState<boolean>(false)
  const [channelId, setSelectedChannelId] = useState<number | null>(null)
  const [compaignDefaultType, setCompaignDefaultType] = useState<CHANNEL>(
    CHANNEL.WHATSAPP
  )

  const [isAudienceModalOpen, setIsAudienceModalOpen] = useState<boolean>(false)
  const [templateModal, setTemplateModal] = useState<boolean>(false)
  const [campaignStatus, setCampaignStatus] = useState<CAMPAIGNSTATUS | null>(
    null
  )

  const [isEditAudienceMode, setIsEditAudienceMode] = useState<boolean>(true)
  const { data: audienceCount, refetch } = useFetchAudienceCountQuery(
    { audienceId },
    { skip: !audienceId }
  )
  const {
    data: advertisement,
    isLoading: isLoadingAdvertisement,
    refetch: refetchAdvertisementList
  } = useFetchAdvertisementListQuery({})

  const { data: whatsAppChannel } = useGetChannelOnboardingsQuery({})

  const whatsappBusinessOptions =
    whatsAppChannel?.content
      ?.filter((item) => item.channel === 'WHATSAPP')
      ?.map((item) => ({
        label: item.businessInfo,
        value: item.channelId
      })) ?? []

  const phoneIdData =
    whatsAppChannel?.content
      ?.filter((adv: any) => Boolean(adv?.phone_id))
      .map((adv: any) => ({
        label: adv.phone_id,
        value: adv.phone_id
      })) ?? []

  const advertisementData = advertisement?.content
    ?.filter((adv: any) => adv?.active)
    ?.map((adv: any) => ({
      label: adv?.name,
      value: adv?.id
    }))

  useEffect(() => {
    if (audienceId) {
      refetch()
    }
  }, [audienceId, refetch])
  useEffect(() => {
    if (campaignId) {
      setSelectedChannelId(
        campaign?.channelId ? Number(campaign.channelId) : null
      )
    }
  }, [campaignId, campaign?.channelId])

  const effectiveChannel: CHANNEL = isEditMode
    ? (campaign?.channel ?? defaultType)
    : (compaignDefaultType ?? defaultType)

  const isWhatsAppChannel = effectiveChannel === CHANNEL.WHATSAPP
  const isSMSChannel = effectiveChannel === CHANNEL.SMS
  const shouldFetchTemplates =
    (isWhatsAppChannel && !!channelId) || isSMSChannel
  const {
    data: templateData,
    isLoading: isTemplateLoading,
    refetch: refetchTemplateList
  } = useGetTemplatesQuery(
    isSMSChannel
      ? {
          filters: [
            {
              fieldName: 'channel',
              fieldValue: CHANNEL.SMS,
              operator: 'EQUALS'
            }
          ]
        }
      : channelId
        ? {
            filters: [
              {
                fieldName: 'channelId',
                fieldValue: channelId,
                operator: 'EQUALS'
              }
            ]
          }
        : { filters: [] },
    { skip: !shouldFetchTemplates }
  )

  const generateOptions = (data: any | undefined, isLoading: boolean) =>
    isLoading
      ? []
      : (data?.content?.map((item: { name: string, id: number }) => ({
          label: item.name,
          value: item.id
        })) ?? [])
  const audienceOptions = generateOptions(audienceData, isAudienceLoading)
  const waTemplateOptions = useMemo(() => {
    if (isTemplateLoading) return []
    const list = templateData?.data ?? []
    return list
      .filter((t: any) => t.status === 'APPROVED' && t.category === 'MARKETING')
      .map((t: any) => ({
        label: t.name,
        value: String(t.id)
      }))
  }, [templateData, isTemplateLoading])
  const SMStemplateOptions =
    templateData?.content?.map((template) => ({
      label: template.name,
      value: template.id
    })) || []

  const initialValues = useMemo(() => {
    let formValues =
      campaignId && campaign
        ? getInitialFormValuesResponse(campaign)
        : { ...defaultCompaignFormValues, channel: defaultType }

    if (isEditMode) {
      formValues = {
        ...formValues,
        channel: campaign?.channel ?? defaultType
      }
    }
    if (isCopyMode && formValues.name) {
      formValues.name = `${formValues.name} 1`
    }
    return formValues
  }, [campaignId, campaign, isEditMode, isCopyMode, defaultType])
  useEffect(() => {
    const initAudienceId = initialValues?.[COMPAIGN_FORM_FIELDS.AUDIENCE]?.id
    setAudienceId(initAudienceId || null)
  }, [initialValues])

  const selectedTemplateId = String(
    initialValues?.[COMPAIGN_FORM_FIELDS.TEMPLATEID] ?? ''
  )

  const waOptionsWithSelected = useMemo(() => {
    if (!selectedTemplateId) return waTemplateOptions
    const exists = waTemplateOptions.some((o) => o.value === selectedTemplateId)
    if (exists) return waTemplateOptions

    const fallbackLabel =
      initialValues?.[COMPAIGN_FORM_FIELDS.TEMPLATENAME] || 'Current Template'

    return [
      ...waTemplateOptions,
      { label: fallbackLabel, value: selectedTemplateId }
    ]
  }, [waTemplateOptions, selectedTemplateId, initialValues])
  const [createCampaign] = useCreateCampaignMutation()
  const [createAppCampaign] = useCreateAppCampaignMutation()
  const [updateCampaign] = useUpdateCampaignMutation()
  const [updateWhatsappCampaign] = useUpdateWhatsappCampaignMutation()
  const onSubmit = async (
    formValues: CompaignForm,
    { setSubmitting }: FormikHelpers<CompaignForm>
  ) => {
    let campaignDTO: Campaign | null = null
    let AppCampaignDTO: AppCampaign | null = null
    let SMSCampaignDTO: AppCampaign | null = null

    if (formValues.channel === CHANNEL.INAPP) {
      AppCampaignDTO = {
        name: formValues.name,
        description: formValues.description,
        scheduleDateTime: formValues.scheduleDateTime,
        channel: formValues.channel,
        scheduleEndDate: formValues.scheduleEndDate,
        status: campaignStatus ?? formValues.status,
        audience: {
          id: formValues.audience?.id ?? 0
        },
        advertisement: {
          id: formValues.advertisement?.id ?? 0
        }
      }
    } else if (formValues.channel === CHANNEL.SMS) {
      SMSCampaignDTO = {
        name: formValues.name,
        description: formValues.description,
        scheduleDateTime: formValues.scheduleDateTime,
        channel: formValues.channel,
        scheduleEndDate: formValues.scheduleEndDate,
        status: campaignStatus ?? formValues.status,
        template: {
          id: Number(formValues.templateId)
        },
        audience: {
          id: formValues.audience?.id ?? 0
        }
      }
    } else {
      campaignDTO = {
        [COMPAIGN_FORM_FIELDS.NAME]: formValues[COMPAIGN_FORM_FIELDS.NAME],
        [COMPAIGN_FORM_FIELDS.ADVERTISEMENT_NAME]:
          formValues[COMPAIGN_FORM_FIELDS.ADVERTISEMENT_NAME],
        [COMPAIGN_FORM_FIELDS.PHONE_ID]:
          formValues[COMPAIGN_FORM_FIELDS.PHONE_ID],
        [COMPAIGN_FORM_FIELDS.WHATSAPP_CHANNEL]:
          formValues[COMPAIGN_FORM_FIELDS.WHATSAPP_CHANNEL],
        [COMPAIGN_FORM_FIELDS.DESCRIPTION]:
          formValues[COMPAIGN_FORM_FIELDS.DESCRIPTION],
        [COMPAIGN_FORM_FIELDS.CHANNEL_TYPE]:
          formValues[COMPAIGN_FORM_FIELDS.CHANNEL_TYPE],
        [COMPAIGN_FORM_FIELDS.SCHEDULE_DATE_TIME]:
          formValues[COMPAIGN_FORM_FIELDS.SCHEDULE_DATE_TIME],
        [COMPAIGN_FORM_FIELDS.STATUS]:
          campaignStatus ?? formValues[COMPAIGN_FORM_FIELDS.STATUS],
        [COMPAIGN_FORM_FIELDS.TEMPLATEID]:
          formValues[COMPAIGN_FORM_FIELDS.TEMPLATEID],
        [COMPAIGN_FORM_FIELDS.AUDIENCE]: {
          id: formValues.audience.id,
          name: formValues.audience.name
        },
        [COMPAIGN_FORM_FIELDS.ESTIMATEDUSER]: audienceCount ?? 0
      }
    }

    try {
      if (AppCampaignDTO) {
        if (isCopyMode) {
          await createAppCampaign(AppCampaignDTO).unwrap()
          notifySuccess('Campaign created successfully!')
        } else if (campaignId) {
          await updateCampaign({
            payload: { ...AppCampaignDTO, id: campaignId }
          }).unwrap()
          notifySuccess('Campaign updated successfully!')
        } else {
          await createAppCampaign(AppCampaignDTO).unwrap()
          notifySuccess('Campaign created successfully!')
        }
      } else if (campaignDTO) {
        if (isCopyMode) {
          await createCampaign(campaignDTO).unwrap()
          notifySuccess('Campaign created successfully!')
        } else if (campaignId) {
          await updateWhatsappCampaign({
            payload: { ...campaignDTO, id: campaignId }
          }).unwrap()
          notifySuccess('Campaign updated successfully!')
        } else {
          await createCampaign(campaignDTO).unwrap()
          notifySuccess('Campaign created successfully!')
        }
      } else if (SMSCampaignDTO) {
        if (isCopyMode) {
          await createAppCampaign(SMSCampaignDTO).unwrap()
          notifySuccess('Campaign created successfully!')
        } else if (campaignId) {
          await updateCampaign({
            payload: { ...SMSCampaignDTO, id: campaignId }
          }).unwrap()
          notifySuccess('Campaign updated successfully!')
        } else {
          await createAppCampaign(SMSCampaignDTO).unwrap()
          notifySuccess('Campaign created successfully!')
        }
      } else {
        notifyError('Campaign data is missing.', { containerId: 'modalToast' })
      }

      onClose()
    } catch (error) {
      notifyError((error as any).data?.message || 'Failed To Save Compaign', {
        containerId: 'modalToast'
      })
    } finally {
      setSubmitting(false)
    }
  }
  const getRange = (count: number) => {
    if (count < 100) return '1-100'

    const start = 10 ** Math.floor(Math.log10(count))
    const end = start * 10

    return `${start} - ${end}`
  }

  const handleAudienceClose = () => {
    setIsAudienceModalOpen(false)
    refetchAudienceList()
  }
  const handleTemplateClose = () => {
    setTemplateModal(false)
    refetchTemplateList()
    refetchAdvertisementList()
  }

  const renderFormButtons = (formikProps: FormikProps<CompaignForm>) => (
    <ButtonToolbar>
      {isEditMode ? (
        <>
          <Button
            className="formButton"
            id="reset"
            onClick={() => {
              formikProps.resetForm()
              setWhatsAppPreview(false)
              refetch()
            }}
          >
            Reset to default
          </Button>
          <Button
            className="formButton"
            type="submit"
            appearance="primary"
            disabled={formikProps.isValidating || formikProps.isSubmitting}
          >
            Save changes
          </Button>
        </>
      ) : (
        <>
          <Button
            className="formButton-3"
            appearance="ghost"
            disabled={formikProps.isValidating || formikProps.isSubmitting}
            onClick={() => {
              setCampaignStatus(CAMPAIGNSTATUS.DRAFT)
              formikProps.handleSubmit()
            }}
          >
            Save as Draft
          </Button>
          <Button
            className="formButton-3"
            id="reset"
            type="button"
            onClick={() => {
              formikProps.resetForm()
              setWhatsAppPreview(false)
              refetch()
            }}
          >
            Reset
          </Button>
          <Button
            className="formButton-3"
            appearance="primary"
            type="submit"
            disabled={formikProps.isValidating || formikProps.isSubmitting}
            onClick={() => setCampaignStatus(CAMPAIGNSTATUS.SCHEDULE)}
          >
            Schedule
          </Button>
        </>
      )}
    </ButtonToolbar>
  )

  return (
    <>
      <Modal
        secondary
        open={open}
        onClose={onClose}
        title={isEditMode ? 'Edit Campaign' : 'Create Campaign'}
        size="calc(60% - 120px)"
        body={
          <div className="create-edit-campaign-wrapper">
            <div className="campaign-preview-section" />
            {selectedTemplate && (
              <WhatsAppPreview
                className="campaign-preview"
                open={whatsAppPreview}
                selectedTemplate={selectedTemplate}
                onClose={() => {
                  setWhatsAppPreview(false)
                }}
              />
            )}
            {selectedTemplate && (
              <SMSTemplatePreview
                className="campaign-preview"
                open={SMSPreview}
                selectedTemplate={selectedTemplate}
                onClose={() => {
                  setSMSPreview(false)
                }}
              />
            )}
            {selectedAdvertisementTemplate && (
              <AdvertisementTemplateView
                className="campaign-preview"
                open={AdvertisementPreview}
                isCompaignAdvertisement
                selectedAdvertisementTemplate={selectedAdvertisementTemplate}
                onClose={() => {
                  setAdvertisementPreview(false)
                }}
              />
            )}
            <div className="campaign-form-section">
              <Formik
                initialValues={initialValues}
                validationSchema={compaignValidationSchema}
                onSubmit={onSubmit}
                enableReinitialize
              >
                {(formikProps: FormikProps<CompaignForm>) => (
                  <Form className="create-edit">
                    <Panel>
                      <Section title="Channel Type">
                        <Row>
                          <Col xs={12}>
                            <RadioGroup
                              name={CHANNEL_TYPE}
                              inline
                              value={formikProps.values.channel}
                              onChange={(value) => {
                                const selectedType = value as CHANNEL
                                formikProps.resetForm({
                                  values: {
                                    ...initialValues,
                                    channel: selectedType
                                  }
                                })

                                formikProps.setFieldValue(CHANNEL_TYPE, value)
                                setCompaignDefaultType(value as CHANNEL)

                                setWhatsAppPreview(false)
                              }}
                              disabled={isCopyMode || isEditMode}
                            >
                              <Radio value={CHANNEL?.WHATSAPP}>WhatsApp</Radio>
                              <Radio value={CHANNEL?.SMS}>SMS</Radio>
                              <Radio value={CHANNEL?.INAPP}>APP</Radio>
                            </RadioGroup>
                          </Col>
                        </Row>
                      </Section>
                      {formikProps.values.channel === CHANNEL?.WHATSAPP && (
                        <>
                          <Section title="Whatsapp Channel Details">
                            <Row>
                              <Col xs={12}>
                                <SelectPicker
                                  data={whatsappBusinessOptions ?? []}
                                  placeholder="Select Whatsapp Account"
                                  value={
                                    formikProps.values[
                                      COMPAIGN_FORM_FIELDS.WHATSAPP_CHANNEL
                                    ] || null
                                  }
                                  onChange={(value) => {
                                    formikProps.setFieldValue(
                                      COMPAIGN_FORM_FIELDS.WHATSAPP_CHANNEL,
                                      value
                                    )
                                    setSelectedChannelId(
                                      value ? Number(value) : null
                                    )
                                  }}
                                  style={{ width: '30rem' }}
                                  disabled={isCopyMode || isEditMode}
                                />
                                <FormikErrorMessage name="channelId" />
                              </Col>

                              <Col xs={12}>
                                <SelectPicker
                                  data={phoneIdData ?? []}
                                  placeholder="Select Phone Id"
                                  value={
                                    formikProps.values[
                                      COMPAIGN_FORM_FIELDS.PHONE_ID
                                    ] || null
                                  }
                                  onChange={(value) => {
                                    formikProps.setFieldValue(
                                      COMPAIGN_FORM_FIELDS.PHONE_ID,
                                      value
                                    )
                                  }}
                                  style={{ width: '30rem' }}
                                  disabled={isCopyMode || isEditMode}
                                />
                                <FormikErrorMessage name="phone_id" />
                              </Col>
                            </Row>
                          </Section>
                          <Section title="Campaign Details">
                            <Row>
                              <Col xs={12}>
                                <TextInput
                                  id={COMPAIGN_FORM_FIELDS.NAME}
                                  formik={formikProps}
                                  name={NAME}
                                  placeholder="Enter campaign name"
                                />

                                <FormikErrorMessage name={NAME} />
                              </Col>
                              <Col xs={12}>
                                <DatePicker
                                  oneTap
                                  name={SCHEDULE_DATE_TIME}
                                  value={
                                    formikProps.values.scheduleDateTime
                                      ? new Date(
                                          formikProps.values.scheduleDateTime
                                        )
                                      : null
                                  }
                                  onChange={(value) => {
                                    formikProps.setFieldValue(
                                      SCHEDULE_DATE_TIME,
                                      value
                                    )
                                    formikProps.setTouched(
                                      {
                                        ...formikProps.touched,
                                        [SCHEDULE_DATE_TIME]: true
                                      },
                                      false
                                    )
                                    formikProps.validateField(
                                      SCHEDULE_DATE_TIME
                                    )
                                  }}
                                  format="yyyy-MM-dd HH:mm"
                                  block
                                  showMeridian
                                  placeholder="Select schedule date"
                                  disabledDate={(date) => {
                                    if (!date) return true
                                    const today = new Date()
                                    today.setHours(0, 0, 0, 0)
                                    return date < today
                                  }}
                                />
                                <FormikErrorMessage name={SCHEDULE_DATE_TIME} />
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <SelectPicker
                                  data={audienceOptions}
                                  placeholder={
                                    isAudienceLoading
                                      ? 'Loading audience...'
                                      : 'Select audience'
                                  }
                                  value={
                                    formikProps.values[
                                      COMPAIGN_FORM_FIELDS.AUDIENCE
                                    ]?.id
                                  }
                                  onChange={(value) => {
                                    const selectedAudience =
                                      audienceOptions.find(
                                        (audience: {
                                          value: number,
                                          label: string
                                        }) => audience.value === value
                                      )
                                    setAudienceId(value)
                                    formikProps.setFieldValue(
                                      COMPAIGN_FORM_FIELDS.AUDIENCE,
                                      {
                                        id: value,
                                        name: selectedAudience?.label || ''
                                      }
                                    )
                                    formikProps.setFieldTouched(
                                      COMPAIGN_FORM_FIELDS.AUDIENCE,
                                      true,
                                      false
                                    )
                                  }}
                                  className="campaign-dropdown"
                                  block
                                  disabled={isAudienceLoading}
                                />
                                <Plus
                                  className="dropdown-plus-button"
                                  onClick={() => setIsAudienceModalOpen(true)}
                                />
                                <FormikErrorMessage
                                  name={COMPAIGN_FORM_FIELDS.AUDIENCE}
                                />
                              </Col>
                              <Col xs={12}>
                                <SelectPicker
                                  data={waOptionsWithSelected}
                                  placeholder={
                                    isTemplateLoading
                                      ? 'Loading template...'
                                      : 'Select template'
                                  }
                                  value={
                                    formikProps.values[
                                      COMPAIGN_FORM_FIELDS.TEMPLATEID
                                    ]
                                      ? String(
                                          formikProps.values[
                                            COMPAIGN_FORM_FIELDS.TEMPLATEID
                                          ]
                                        )
                                      : null
                                  }
                                  onChange={(value) => {
                                    formikProps.setFieldValue(
                                      COMPAIGN_FORM_FIELDS.TEMPLATEID,
                                      value
                                    )
                                    formikProps.setTouched(
                                      {
                                        ...formikProps.touched,
                                        [COMPAIGN_FORM_FIELDS.TEMPLATEID]: true
                                      },
                                      false
                                    )
                                    formikProps.validateField(
                                      COMPAIGN_FORM_FIELDS.TEMPLATEID
                                    )

                                    const templateDetails =
                                      templateData?.data?.find(
                                        (t: WhatsAppTemplate) => t.id === value
                                      )
                                    setSelectedTemplate(templateDetails || null)
                                    setWhatsAppPreview(!!templateDetails)
                                  }}
                                  renderMenuItem={(label, item) => {
                                    const templateDetails =
                                      templateData?.data?.find(
                                        (t: WhatsAppTemplate) =>
                                          t.id === item.value
                                      )

                                    return (
                                      <div
                                        onMouseEnter={() => {
                                          if (templateDetails) {
                                            setSelectedTemplate(templateDetails)
                                            setWhatsAppPreview(true)
                                          }
                                        }}
                                        onMouseLeave={() => {
                                          setTimeout(() => {
                                            const isTemplateStillSelected =
                                              !!formikProps.values[
                                                COMPAIGN_FORM_FIELDS.TEMPLATEID
                                              ]
                                            if (!isTemplateStillSelected) {
                                              setWhatsAppPreview(false)
                                              setSelectedTemplate(null)
                                            }
                                          })
                                        }}
                                      >
                                        {label}
                                      </div>
                                    )
                                  }}
                                  className="advertisement-dropdown"
                                  block
                                  disabled={
                                    formikProps.values.channel ===
                                      CHANNEL.WHATSAPP &&
                                    !formikProps.values[
                                      COMPAIGN_FORM_FIELDS.WHATSAPP_CHANNEL
                                    ]
                                  }
                                />
                                <Plus
                                  className="dropdown-plus-button"
                                  onClick={() => setTemplateModal(true)}
                                />
                                <FormikErrorMessage
                                  name={COMPAIGN_FORM_FIELDS.TEMPLATEID}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <TextInput
                                  id={COMPAIGN_FORM_FIELDS.DESCRIPTION}
                                  formik={formikProps}
                                  name={DESCRIPTION}
                                  placeholder="Description"
                                  as="textarea"
                                  rows={5}
                                />
                                <FormikErrorMessage name={DESCRIPTION} />
                              </Col>
                              {isEditMode && (
                                <Col xs={12}>
                                  <SelectPicker
                                    id={COMPAIGN_FORM_FIELDS.STATUS}
                                    searchable={false}
                                    placeholder="Select status"
                                    data={
                                      campaign?.status ===
                                        CAMPAIGNSTATUS.CANCEL ||
                                      campaign?.status ===
                                        CAMPAIGNSTATUS.SCHEDULE
                                        ? [
                                            {
                                              label: 'Cancel',
                                              value: CAMPAIGNSTATUS.CANCEL
                                            },
                                            {
                                              label: 'Schedule',
                                              value: CAMPAIGNSTATUS.SCHEDULE
                                            }
                                          ]
                                        : [
                                            {
                                              label: 'Cancel',
                                              value: CAMPAIGNSTATUS.CANCEL
                                            },
                                            {
                                              label: 'Schedule',
                                              value: CAMPAIGNSTATUS.SCHEDULE
                                            },
                                            {
                                              label: 'Draft',
                                              value: CAMPAIGNSTATUS.DRAFT
                                            }
                                          ]
                                    }
                                    value={
                                      formikProps.values[
                                        COMPAIGN_FORM_FIELDS.STATUS
                                      ]
                                    }
                                    onChange={(value) => {
                                      formikProps.setFieldValue(
                                        COMPAIGN_FORM_FIELDS.STATUS,
                                        value
                                      )
                                    }}
                                    className="action-dropdown"
                                    block
                                  />
                                </Col>
                              )}
                            </Row>
                          </Section>
                        </>
                      )}
                      {formikProps.values.channel === CHANNEL.SMS && (
                        <Section title="Campaign Details">
                          <Row>
                            <Col xs={12}>
                              <TextInput
                                id={COMPAIGN_FORM_FIELDS.NAME}
                                formik={formikProps}
                                name={NAME}
                                placeholder="Enter campaign name"
                              />

                              <FormikErrorMessage name={NAME} />
                            </Col>
                            <Col xs={12}>
                              <DatePicker
                                oneTap
                                name={SCHEDULE_DATE_TIME}
                                value={
                                  formikProps.values.scheduleDateTime
                                    ? new Date(
                                        formikProps.values.scheduleDateTime
                                      )
                                    : null
                                }
                                onChange={(value) => {
                                  formikProps.setFieldValue(
                                    SCHEDULE_DATE_TIME,
                                    value
                                  )
                                  formikProps.setTouched(
                                    {
                                      ...formikProps.touched,
                                      [SCHEDULE_DATE_TIME]: true
                                    },
                                    false
                                  )
                                  formikProps.validateField(SCHEDULE_DATE_TIME)
                                }}
                                format="yyyy-MM-dd HH:mm"
                                block
                                showMeridian
                                placeholder="Select schedule date"
                              />
                              <FormikErrorMessage name={SCHEDULE_DATE_TIME} />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <SelectPicker
                                data={audienceOptions}
                                placeholder={
                                  isAudienceLoading
                                    ? 'Loading audience...'
                                    : 'Select audience'
                                }
                                value={
                                  formikProps.values[
                                    COMPAIGN_FORM_FIELDS.AUDIENCE
                                  ]?.id
                                }
                                onChange={(value) => {
                                  const selectedAudience = audienceOptions.find(
                                    (audience: {
                                      value: number,
                                      label: string
                                    }) => audience.value === value
                                  )
                                  setAudienceId(value)
                                  formikProps.setFieldValue(
                                    COMPAIGN_FORM_FIELDS.AUDIENCE,
                                    {
                                      id: value,
                                      name: selectedAudience?.label || ''
                                    }
                                  )
                                  formikProps.setFieldTouched(
                                    COMPAIGN_FORM_FIELDS.AUDIENCE,
                                    true,
                                    false
                                  )
                                }}
                                className="campaign-dropdown"
                                block
                                disabled={isAudienceLoading}
                              />
                              <Plus
                                className="dropdown-plus-button"
                                onClick={() => setIsAudienceModalOpen(true)}
                              />
                              <FormikErrorMessage
                                name={COMPAIGN_FORM_FIELDS.AUDIENCE}
                              />
                            </Col>
                            <Col xs={12}>
                              <SelectPicker
                                data={SMStemplateOptions}
                                placeholder={
                                  isTemplateLoading
                                    ? 'Loading template...'
                                    : 'Select template'
                                }
                                value={
                                  formikProps.values[
                                    COMPAIGN_FORM_FIELDS.TEMPLATEID
                                  ]
                                }
                                onChange={(value) => {
                                  formikProps.setFieldValue(
                                    COMPAIGN_FORM_FIELDS.TEMPLATEID,
                                    value
                                  )
                                  formikProps.setTouched(
                                    {
                                      ...formikProps.touched,
                                      [COMPAIGN_FORM_FIELDS.TEMPLATEID]: true
                                    },
                                    false
                                  )
                                  formikProps.validateField(
                                    COMPAIGN_FORM_FIELDS.TEMPLATEID
                                  )

                                  const templateDetails =
                                    templateData?.data?.find(
                                      (t: WhatsAppTemplate) => t.id === value
                                    )

                                  setSelectedTemplate(templateDetails || null)
                                  setSMSPreview(!!templateDetails)
                                }}
                                renderMenuItem={(label, item) => {
                                  const templateDetails =
                                    templateData?.content?.find(
                                      (t: WhatsAppTemplate) =>
                                        t.id === item.value
                                    )

                                  return (
                                    <div
                                      onMouseEnter={() => {
                                        if (templateDetails) {
                                          setSelectedTemplate(templateDetails)
                                          setSMSPreview(true)
                                        }
                                      }}
                                      onMouseLeave={() => {
                                        setTimeout(() => {
                                          const isTemplateStillSelected =
                                            !!formikProps.values[
                                              COMPAIGN_FORM_FIELDS.TEMPLATEID
                                            ]
                                          if (!isTemplateStillSelected) {
                                            setSMSPreview(false)
                                            setSelectedTemplate(null)
                                          }
                                        })
                                      }}
                                    >
                                      {label}
                                    </div>
                                  )
                                }}
                                className="advertisement-dropdown"
                                block
                              />
                              <Plus
                                className="dropdown-plus-button"
                                onClick={() => setTemplateModal(true)}
                              />
                              <FormikErrorMessage
                                name={COMPAIGN_FORM_FIELDS.TEMPLATEID}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <TextInput
                                id={COMPAIGN_FORM_FIELDS.DESCRIPTION}
                                formik={formikProps}
                                name={DESCRIPTION}
                                placeholder="Description"
                                as="textarea"
                                rows={5}
                              />
                              <FormikErrorMessage name={DESCRIPTION} />
                            </Col>
                            {isEditMode && (
                              <Col xs={12}>
                                <SelectPicker
                                  id={COMPAIGN_FORM_FIELDS.STATUS}
                                  searchable={false}
                                  placeholder="Select status"
                                  data={
                                    campaign?.status ===
                                      CAMPAIGNSTATUS.CANCEL ||
                                    campaign?.status === CAMPAIGNSTATUS.SCHEDULE
                                      ? [
                                          {
                                            label: 'Cancel',
                                            value: CAMPAIGNSTATUS.CANCEL
                                          },
                                          {
                                            label: 'Schedule',
                                            value: CAMPAIGNSTATUS.SCHEDULE
                                          }
                                        ]
                                      : [
                                          {
                                            label: 'Cancel',
                                            value: CAMPAIGNSTATUS.CANCEL
                                          },
                                          {
                                            label: 'Schedule',
                                            value: CAMPAIGNSTATUS.SCHEDULE
                                          },
                                          {
                                            label: 'Draft',
                                            value: CAMPAIGNSTATUS.DRAFT
                                          }
                                        ]
                                  }
                                  value={
                                    formikProps.values[
                                      COMPAIGN_FORM_FIELDS.STATUS
                                    ]
                                  }
                                  onChange={(value) => {
                                    formikProps.setFieldValue(
                                      COMPAIGN_FORM_FIELDS.STATUS,
                                      value
                                    )
                                  }}
                                  className="action-dropdown"
                                  block
                                />
                              </Col>
                            )}
                          </Row>
                        </Section>
                      )}
                      {formikProps.values.channel === CHANNEL.INAPP && (
                        <>
                          <Section title="Audience Details">
                            <Row>
                              <Col xs={12}>
                                <SelectPicker
                                  data={audienceOptions}
                                  placeholder={
                                    isAudienceLoading
                                      ? 'Loading audience...'
                                      : 'Select audience'
                                  }
                                  value={
                                    formikProps.values[
                                      COMPAIGN_FORM_FIELDS.AUDIENCE
                                    ]?.id
                                  }
                                  onChange={(value) => {
                                    const selectedAudience =
                                      audienceOptions.find(
                                        (audience: {
                                          value: number,
                                          label: string
                                        }) => audience.value === value
                                      )
                                    setAudienceId(value)
                                    formikProps.setFieldValue(
                                      COMPAIGN_FORM_FIELDS.AUDIENCE,
                                      {
                                        id: value,
                                        name: selectedAudience?.label || ''
                                      }
                                    )
                                    formikProps.setFieldTouched(
                                      COMPAIGN_FORM_FIELDS.AUDIENCE,
                                      true,
                                      false
                                    )
                                  }}
                                  className="campaign-dropdown"
                                  block
                                  disabled={isAudienceLoading}
                                />
                                <Plus
                                  className="dropdown-plus-button"
                                  onClick={() => setIsAudienceModalOpen(true)}
                                />
                                <FormikErrorMessage
                                  name={COMPAIGN_FORM_FIELDS.AUDIENCE}
                                />
                              </Col>
                            </Row>
                          </Section>
                          <Section title="Campaign Details">
                            <Row>
                              <Col xs={12}>
                                <TextInput
                                  id={COMPAIGN_FORM_FIELDS.NAME}
                                  formik={formikProps}
                                  name={NAME}
                                  placeholder="Enter campaign name"
                                />

                                <FormikErrorMessage name={NAME} />
                              </Col>
                              <Col xs={12}>
                                <SelectPicker
                                  data={advertisementData ?? []}
                                  placeholder={
                                    isLoadingAdvertisement
                                      ? 'Loading Template...'
                                      : 'Select Template'
                                  }
                                  value={
                                    formikProps.values[
                                      COMPAIGN_FORM_FIELDS.ADVERTISEMENT
                                    ]?.id
                                  }
                                  onChange={(value) => {
                                    const selectedAdevertisement =
                                      advertisementData?.find(
                                        (adv: any) => adv.value === value
                                      )

                                    formikProps.setFieldValue(
                                      COMPAIGN_FORM_FIELDS.ADVERTISEMENT,
                                      {
                                        id: value,
                                        name:
                                          selectedAdevertisement?.label || ''
                                      }
                                    )
                                    formikProps.validateField(
                                      COMPAIGN_FORM_FIELDS.ADVERTISEMENT
                                    )

                                    const templateDetails =
                                      advertisement?.content?.find(
                                        (t: Advertisement) => t.id === value
                                      )

                                    setSelectedAdvertisementTemplate(
                                      templateDetails || null
                                    )
                                    setAdvertisementPreview(!!templateDetails)
                                  }}
                                  renderMenuItem={(label, item) => {
                                    const templateDetails =
                                      advertisement?.content?.find(
                                        (t: Advertisement) =>
                                          t.id === item.value
                                      )
                                    return (
                                      <div
                                        onMouseEnter={() => {
                                          if (templateDetails) {
                                            setSelectedAdvertisementTemplate(
                                              templateDetails
                                            )
                                            setAdvertisementPreview(true)
                                          }
                                        }}
                                        onMouseLeave={() => {
                                          setTimeout(() => {
                                            const isTemplateStillSelected =
                                              !!formikProps.values[
                                                COMPAIGN_FORM_FIELDS.TEMPLATEID
                                              ]
                                            if (!isTemplateStillSelected) {
                                              setAdvertisementPreview(false)
                                              setSelectedAdvertisementTemplate(
                                                null
                                              )
                                            }
                                          })
                                        }}
                                      >
                                        {label}
                                      </div>
                                    )
                                  }}
                                  style={{ width: '30rem' }}
                                />
                                <Plus
                                  className="dropdown-plus-button"
                                  onClick={() => setTemplateModal(true)}
                                />
                                <FormikErrorMessage
                                  name={COMPAIGN_FORM_FIELDS.ADVERTISEMENT}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <DatePicker
                                  oneTap
                                  name={SCHEDULE_DATE_TIME}
                                  value={
                                    formikProps.values.scheduleDateTime
                                      ? new Date(
                                          formikProps.values.scheduleDateTime
                                        )
                                      : null
                                  }
                                  onChange={(value) => {
                                    formikProps.setFieldValue(
                                      SCHEDULE_DATE_TIME,
                                      value
                                    )
                                    formikProps.setTouched(
                                      {
                                        ...formikProps.touched,
                                        [SCHEDULE_DATE_TIME]: true
                                      },
                                      false
                                    )
                                    formikProps.validateField(
                                      SCHEDULE_DATE_TIME
                                    )
                                  }}
                                  format="yyyy-MM-dd HH:mm"
                                  block
                                  showMeridian
                                  placeholder="Start Date"
                                  disabledDate={(date) => {
                                    if (!date) return true
                                    const today = new Date()
                                    today.setHours(0, 0, 0, 0)
                                    return date < today
                                  }}
                                />

                                <FormikErrorMessage name={SCHEDULE_DATE_TIME} />
                              </Col>
                              <Col xs={12}>
                                <DatePicker
                                  oneTap
                                  name={SCHEDULE_END_DATE}
                                  value={
                                    formikProps.values.scheduleEndDate
                                      ? new Date(
                                          formikProps.values.scheduleEndDate
                                        )
                                      : null
                                  }
                                  onChange={(value) => {
                                    formikProps.setFieldValue(
                                      SCHEDULE_END_DATE,
                                      value
                                    )
                                    formikProps.setTouched(
                                      {
                                        ...formikProps.touched,
                                        [SCHEDULE_END_DATE]: true
                                      },
                                      false
                                    )
                                    formikProps.validateField(SCHEDULE_END_DATE)
                                  }}
                                  format="yyyy-MM-dd HH:mm"
                                  block
                                  showMeridian
                                  placeholder="End Date"
                                  disabledDate={(date) => {
                                    if (!date) return true
                                    const today = new Date()
                                    today.setHours(0, 0, 0, 0)
                                    return date < today
                                  }}
                                />
                                <FormikErrorMessage name={SCHEDULE_END_DATE} />
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <TextInput
                                  id={COMPAIGN_FORM_FIELDS.DESCRIPTION}
                                  formik={formikProps}
                                  name={DESCRIPTION}
                                  placeholder="Description"
                                  as="textarea"
                                  rows={5}
                                />
                                <FormikErrorMessage name={DESCRIPTION} />
                              </Col>
                              {isEditMode && (
                                <Col xs={12}>
                                  <SelectPicker
                                    id={COMPAIGN_FORM_FIELDS.STATUS}
                                    searchable={false}
                                    placeholder="Select status"
                                    data={
                                      campaign?.status ===
                                        CAMPAIGNSTATUS.CANCEL ||
                                      campaign?.status ===
                                        CAMPAIGNSTATUS.SCHEDULE
                                        ? [
                                            {
                                              label: 'Cancel',
                                              value: CAMPAIGNSTATUS.CANCEL
                                            },
                                            {
                                              label: 'Schedule',
                                              value: CAMPAIGNSTATUS.SCHEDULE
                                            }
                                          ]
                                        : [
                                            {
                                              label: 'Cancel',
                                              value: CAMPAIGNSTATUS.CANCEL
                                            },
                                            {
                                              label: 'Schedule',
                                              value: CAMPAIGNSTATUS.SCHEDULE
                                            },
                                            {
                                              label: 'Draft',
                                              value: CAMPAIGNSTATUS.DRAFT
                                            }
                                          ]
                                    }
                                    value={
                                      formikProps.values[
                                        COMPAIGN_FORM_FIELDS.STATUS
                                      ]
                                    }
                                    onChange={(value) => {
                                      formikProps.setFieldValue(
                                        COMPAIGN_FORM_FIELDS.STATUS,
                                        value
                                      )
                                    }}
                                    className="action-dropdown"
                                    block
                                  />
                                </Col>
                              )}
                            </Row>
                          </Section>
                        </>
                      )}

                      <Section title="Estimated Users">
                        <Row>
                          <Col xs={24} md={12}>
                            <div className="estimated-users">
                              {audienceCount
                                ? (getRange(audienceCount) ?? 0)
                                : 0}
                            </div>
                          </Col>
                        </Row>
                      </Section>
                    </Panel>

                    <Panel className="panel-buttons">
                      {renderFormButtons(formikProps)}
                    </Panel>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        }
      />
      {templateModal && (
        <CreateTemplate
          open={templateModal}
          onClose={handleTemplateClose}
          defaultType={compaignDefaultType}
        />
      )}
      {isAudienceModalOpen && (
        <CreateEditAudiences
          open={isAudienceModalOpen}
          setOpen={handleAudienceClose}
          isEditMode={isEditAudienceMode}
          setIsEditMode={setIsEditAudienceMode}
          audienceData={null}
        />
      )}
    </>
  )
}

export default CreateEditCampaign
